import type {Assertion} from "../../types";

// Assertions — 7 canonical types shared across all FSAs
export const ASSERTIONS: Assertion[] = [
  {
    id: "existence",
    name: "Existence",
    description:
      "Assets, liabilities, and equity interests exist at the reporting date. Recorded transactions and events have occurred and pertain to the entity.",
  },
  {
    id: "completeness",
    name: "Completeness",
    description:
      "All transactions, events, assets, liabilities, and equity interests that should have been recorded have been recorded. All required disclosures have been included.",
  },
  {
    id: "accuracy",
    name: "Accuracy",
    description:
      "Amounts and other data relating to recorded transactions and events have been recorded appropriately. Related disclosures have been appropriately measured and described.",
  },
  {
    id: "cutoff",
    name: "Cut-off",
    description: "Transactions and events have been recorded in the correct accounting period.",
  },
  {
    id: "valuation",
    name: "Valuation & Allocation",
    description:
      "Assets, liabilities, and equity interests are included at appropriate amounts and any resulting valuation or allocation adjustments are appropriately recorded.",
  },
  {
    id: "rights",
    name: "Rights & Obligations",
    description: "The entity holds or controls the rights to assets and liabilities are the obligations of the entity.",
  },
  {
    id: "presentation",
    name: "Presentation & Disclosure",
    description:
      "Financial information is appropriately presented and described, and disclosures are clearly expressed.",
  },
];
